module.exports = __webpack_public_path__ + "static/media/feature_img_ss1.1ff1ad6c.png";